import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { SearchX } from "lucide-react";
import { usePageMeta } from "../lib/seo";

export default function NotFound() {
  const { pathname } = useLocation();
  usePageMeta("Page not found", "The page you requested does not exist on the Dutsen Kauna Foundation website.");
  useEffect(() => {
    const m = document.createElement("meta"); m.name = "prerender-status-code"; m.content = "404"; document.head.appendChild(m);
    const r = document.createElement("meta"); r.name = "robots"; r.content = "noindex"; document.head.appendChild(r);
    return () => { m.remove(); r.remove(); };
  }, []);
  return (
    <div className="bg-[#f8f4e8] min-h-[70vh] flex items-center" data-testid="not-found-page">
      <div className="dk-container py-20 max-w-2xl">
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#8a6a1f] font-bold flex items-center gap-2"><SearchX size={14} /> Error 404</div>
        <h1 className="font-serif text-4xl sm:text-5xl font-bold text-[#0a0d12] mt-3">We can't find that page.</h1>
        <p className="text-[#0a0d12]/70 mt-4 text-sm sm:text-base">The address <code className="font-mono text-xs bg-white px-1.5 py-0.5 rounded border border-black/10">{pathname}</code> doesn't exist or has moved. Try one of these instead:</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/" className="dk-btn-primary" data-testid="nf-home">Home</Link>
          <Link to="/get-help" className="dk-btn-outline !text-[#0d1724] !border-[#0d1724]" data-testid="nf-get-help">Get help</Link>
          <Link to="/projects" className="dk-btn-outline !text-[#0d1724] !border-[#0d1724]">Projects &amp; impact</Link>
          <Link to="/donate" className="dk-btn-outline !text-[#0d1724] !border-[#0d1724]">Donate</Link>
        </div>
        <p className="text-xs text-[#0a0d12]/50 mt-10">If you followed a link from our site, please <Link to="/contact" className="underline">tell us</Link> so we can fix it.</p>
      </div>
    </div>
  );
}
